const CustomizedDressAttributeLabels = ['Waist', 'Neckline', 'Strap Sleeves', 'Hem', 'Back'];

const CustomizedDressFieldLabels = ['Waist', 'Neckline', 'StrapSleeves', 'Hem', 'Back'];

export function isCustomizeDressAttribute(label: string) {
  return CustomizedDressAttributeLabels.indexOf(label) > -1;
}

export function isCustomizeDressField(label: string) {
  return CustomizedDressFieldLabels.indexOf(label) > -1;
}
